/**
 * DevExtreme (esm/__internal/viz/core/themes/generic/carmine.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
const ACCENT_COLOR = "#f05b41";
const BACKGROUND_COLOR = "#fff";
const TITLE_COLOR = "#333";
const SUBTITLE_COLOR = "#8899a8";
const TEXT_COLOR = "#707070";
const BORDER_COLOR = "#dee1e3";
export default [{
    baseThemeName: "generic.light",
    theme: {
        name: "generic.carmine",
        defaultPalette: "Carmine",
        backgroundColor: "#fff",
        primaryTitleColor: "#333",
        secondaryTitleColor: "#8899a8",
        gridColor: "#dee1e3",
        axisColor: "#707070",
        export: {
            backgroundColor: "#fff",
            font: {
                color: "#333"
            },
            button: {
                default: {
                    color: "#333",
                    borderColor: "#b1b7bd",
                    backgroundColor: "#fff"
                },
                hover: {
                    color: "#333",
                    borderColor: "#b1b7bd",
                    backgroundColor: "#faf2f0"
                },
                focus: {
                    color: "#333",
                    borderColor: "#6d7781",
                    backgroundColor: "#faf2f0"
                },
                active: {
                    color: "#333",
                    borderColor: "#6d7781",
                    backgroundColor: "#f5e7e4"
                }
            }
        },
        legend: {
            font: {
                color: "#707070"
            }
        },
        tooltip: {
            color: "#fff",
            border: {
                color: "#dee1e3"
            },
            font: {
                color: "#333"
            }
        },
        "chart:common": {
            commonSeriesSettings: {
                label: {
                    border: {
                        color: "#dee1e3"
                    }
                }
            }
        },
        "chart:common:annotation": {
            font: {
                color: "#333"
            },
            border: {
                color: "#dee1e3"
            },
            color: "#fff"
        },
        chart: {
            commonPaneSettings: {
                border: {
                    color: "#dee1e3"
                }
            },
            commonAxisSettings: {
                breakStyle: {
                    color: "#c1c5c7"
                }
            }
        },
        rangeSelector: {
            scale: {
                breakStyle: {
                    color: "#c1c5c7"
                },
                tick: {
                    opacity: .12
                }
            },
            selectedRangeColor: "#f05b41",
            sliderMarker: {
                color: "#f05b41"
            },
            sliderHandle: {
                color: "#f05b41",
                opacity: .5
            }
        },
        sparkline: {
            pointColor: "#fff",
            minColor: "#f0ad4e",
            maxColor: "#f74d61"
        },
        treeMap: {
            group: {
                color: "#dee1e3",
                label: {
                    font: {
                        color: "#8899a8"
                    }
                }
            }
        },
        bullet: {
            color: "#f05b41"
        },
        gauge: {
            valueIndicators: {
                rangebar: {
                    color: "#f05b41"
                },
                textcloud: {
                    color: "#f05b41"
                }
            }
        }
    }
}, {
    baseThemeName: "generic.carmine",
    theme: {
        name: "generic.carmine.compact"
    }
}];
